import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {BonusBunniesBaseGameNearWinView} from "./BonusBunniesBaseGameNearWinView";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

/**
 * Created by Jerker Nord on 2020-03-16.
 */

export class BonusBunniesBaseGameNearWinController extends ReelStopPresentationController {

    private _baseGameNearWinView:BonusBunniesBaseGameNearWinView;
    private _nearWinReels:boolean[];
    private _fastNearWinReel:boolean[];
    private _nearWinStarted:boolean = false;
    private _nextMode:string;
    private _bunnyLandedCounter:number;
    private _wildLandedCounter:number;
    private _playAnticipationFailed:boolean;

    constructor(index:number) {
        super(index, "BonusBunniesBaseGameNearWinController");
        this._baseGameNearWinView = new BonusBunniesBaseGameNearWinView();
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._nearWinReels = data.nearWinReels;
        this._fastNearWinReel = data.fastNearWinReels;
        this._nextMode = data.nextMode;
        this._bunnyLandedCounter = 0;
        this._wildLandedCounter = 0;
        this._playAnticipationFailed = false;

        for(let i:number = 0; i < this._fastNearWinReel.length; i++) {
            if(this._fastNearWinReel[i] == true && this._nearWinReels[i] == false) {
                EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_ADD_STOP_DELAY, {
                    reelId : i,
                    delay : 0.5
                }));
                break;
            }
        }

        if(data.mode == BonusBunniesGameMode.NORMAL) {
            for(let i:number = 0; i < data.reels.length - 1; i++) {
                for(let j:number = 0; j < data.reels[i].length - 1; j++) {
                    if(data.reels[i][j] == "W") {
                        this._wildLandedCounter++;
                    }
                    if(data.reels[i][j] == "B") {
                        this._bunnyLandedCounter++;
                    }
                }
            }
            if(this._wildLandedCounter > 0 || this._bunnyLandedCounter > 0) {
                if(this._wildLandedCounter > 0 && this._bunnyLandedCounter == 0) {
                    this._playAnticipationFailed = true;
                }
                if(this._wildLandedCounter == 0 && this._bunnyLandedCounter < 3) {
                    this._playAnticipationFailed = true;
                }
            }
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._gameData!.mode == BonusBunniesGameMode.NORMAL) {
            if(data.reelId < 4) {
                if(this._nearWinReels[data.reelId + 1] == true || this._fastNearWinReel[data.reelId + 1] == true) {
                    if(this._nearWinStarted == false) {
                        this._nearWinStarted = true;
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.ANTICIPATION);
                    }
                    this._baseGameNearWinView.playNearWinTL(data.reelId + 1);
                }
            }
            if(data.reelId == 3) {
                SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.ANTICIPATION);
                if(this._nextMode !== BonusBunniesGameMode.BONUS_GAME && (this._nearWinStarted == true)) {
                    this._nearWinStarted = false;
                    //Play if we have Wilds but no Bunnies OR only Bunnies but less than 3
                    if(this._playAnticipationFailed == true) {
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.ANTICIPATION_FAIL);
                    }
                }
                this.abort();
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    public abort():void {
        this._baseGameNearWinView.removeNearWinAnimation();
        this._nearWinStarted = false;
    }
}